import Cookies from 'js-cookie';

import { cookieConfig } from './config';
import { CookieContextProps } from './CookieConsent';

export const revokeCookies = (service: string) => {
  const cookiePattern = cookieConfig.services[service]?.cookies;

  cookiePattern?.forEach((pattern) => {
    if (typeof pattern === 'string') {
      Cookies.remove(pattern);
    } else {
      Object.keys(Cookies.get()).forEach((cookie) => {
        if (pattern.test(cookie)) {
          Cookies.remove(cookie);
        }
      });
    }
  });
};

export const applyServices = (servicesToApply: Record<string, boolean>, context: CookieContextProps) => {
  const newServices = { ...context.services, ...servicesToApply };

  context.setServices(newServices);
  Cookies.set(cookieConfig.cookieName, JSON.stringify(newServices), {
    expires: cookieConfig.cookieExpires ?? 365,
    path: cookieConfig.cookiePath || '/',
    domain: cookieConfig.cookieDomain || '',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'Lax',
  });

  Object.keys(servicesToApply).forEach((service) => {
    if (!servicesToApply[service]) {
      revokeCookies(service);
    }
  });
};

export const setService = (servicesToSet: string | string[], context: CookieContextProps, consent: boolean) => {
  // accept/revoke multiple services
  if (Array.isArray(servicesToSet)) {
    const configuredServices = Object.keys(cookieConfig.services).reduce(
      (acc, service) => {
        if (servicesToSet.includes(service)) {
          acc[service] = consent;
        }
        return acc;
      }, 
      {} as Record<string, boolean>
    );

    applyServices(configuredServices, context);

    return;
  }

  // accept/revoke single service
  const configuredServices = { [servicesToSet]: consent };

  applyServices(configuredServices, context);
};

export const setAllServices = (context: CookieContextProps, consent: boolean) => {
  const configuredServices: Record<string, boolean> = {};
  Object.keys(cookieConfig.services).forEach((service) => (configuredServices[service] = consent));

  applyServices(configuredServices, context);
};

export const getParsedCookie = () => {
  const cookies = Cookies.get(cookieConfig.cookieName);
  return cookies ? JSON.parse(cookies) : {};
};
